import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { getStepDetails, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import * as RolesRouteMap from 'app-models';
import { environment } from 'environment-configurations';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i6 from 'cache-country-list';
import * as i7 from 'reference-library';
import * as i8 from 'primeng/dynamicdialog';
import * as i9 from '@angular/router';
import * as i10 from 'app-services-library';

class APISelectingLCA {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getApprovedLcaList(visaType, caseType, caseId, socCode) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/soc/${socCode}/lcaCodes`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postLcaSOCCodeSelection(visaType, caseType, caseId, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/occupationDetails`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getLcaSOCCodeSelection(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/occupationDetails`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    deleteUnassignLca(visaType, caseType, caseId, lcaCodeId) {
        return this.httpClient.delete(`/${visaType}/${caseType}/${caseId}/lca/${lcaCodeId}/unassign`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APISelectingLCA.ɵfac = function APISelectingLCA_Factory(t) { return new (t || APISelectingLCA)(i0.ɵɵinject(i1.HttpClient)); };
APISelectingLCA.ɵprov = i0.ɵɵdefineInjectable({ token: APISelectingLCA, factory: APISelectingLCA.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APISelectingLCA, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const DeleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
class BaseSelectingLcaSocLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, dialogService, router, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.lcaList = [];
        this.lcaDocumentList = null;
        this.disabledControls = false;
        this.selectedLcaCode = "";
        this.isBenNotifyLcaLinkPet = false;
    }
    loadInit() {
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (data) {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                // this.isBenNotifyLcaLinkPet = this.stepDetails.isBeneficiaryNotify === 1 ? true : false;
                this.selectLCAForm.reset();
                this.loadAssignedLCA();
                this.toggleControlsStatus();
            }
        });
    }
    afterViewInit() {
        this.selectLCAForm.valueChanges.subscribe(() => {
            if (this.selectLCAForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getSelectedApprovedLca() {
        this.apiService.getApprovedLcaList(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.socCode).subscribe((response) => {
            var _a;
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.lcaList = response.data;
                this.selectedLcaCode = '';
                let filteredLcaList = (_a = response.data) === null || _a === void 0 ? void 0 : _a.filter(x => x.caseNumber == this.listFirstRowLcaCode);
                if (filteredLcaList && filteredLcaList.length) {
                    this.selectedLcaCode = filteredLcaList[0]['lcaId'];
                }
            }
        });
    }
    loadAssignedLCA() {
        this.apiService.getLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).subscribe((response) => {
            var _a, _b, _c, _d;
            if (response === null || response === void 0 ? void 0 : response.data) {
                this.listFirstRowLcaCode = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.lca) === null || _b === void 0 ? void 0 : _b.caseNumber;
                this.assignedLcaList = response.data;
                this.socCode = (_c = response.data) === null || _c === void 0 ? void 0 : _c.specialityOccupation;
                this.isBenNotifyLcaLinkPet = (_d = response.data) === null || _d === void 0 ? void 0 : _d.isBenNotifyLcaLinkPet,
                    // this.lcaDocumentList = response.data.lca.documents[0].fileLocation;
                    this.getSelectedApprovedLca();
            }
        });
    }
    postAssignLca() {
        const payload = {
            lcaCodeId: this.selectedLcaCode,
            isBenNotifyLcaLinkPet: this.isBenNotifyLcaLinkPet,
        };
        this.apiService.postLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, payload).subscribe((response) => {
            if (response && response.status === 200) {
                this.toastr.success(response.message, 'Success');
                this.selectLCAForm.resetForm();
                this.loadAssignedLCA();
            }
        });
    }
    deleteUnassignLCA() {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteUnassignLca(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.assignedLcaList.lcaCodeId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.loadAssignedLCA();
                });
            }
        });
    }
    viewLcaDoc(item) {
        const docPath = item.documents.find(x => x.fileCategory.code === "LCA").fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, "_blank");
    }
    createNewLCA() {
        this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/lca/add-new`], { state: { redirectUrl: this.router.url, redirectPage: 'Back to Petition Builder' } });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.loadAssignedLCA();
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseSelectingLcaSocLibraryService.ɵfac = function BaseSelectingLcaSocLibraryService_Factory(t) { return new (t || BaseSelectingLcaSocLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APISelectingLCA), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DirtyFormGuard), i0.ɵɵinject(i6.CacheCountryListService), i0.ɵɵinject(i7.ReferenceLibraryService), i0.ɵɵinject(i8.DialogService), i0.ɵɵinject(i9.Router), i0.ɵɵinject(i10.AppServicesLibraryService)); };
BaseSelectingLcaSocLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseSelectingLcaSocLibraryService, factory: BaseSelectingLcaSocLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseSelectingLcaSocLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APISelectingLCA }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.CacheCountryListService }, { type: i7.ReferenceLibraryService }, { type: i8.DialogService }, { type: i9.Router }, { type: i10.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-selecting-lca-soc-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APISelectingLCA, BaseSelectingLcaSocLibraryService, DeleteDialogConfigurations };
//# sourceMappingURL=base-selecting-lca-soc-library.js.map
